<template>
    <app-text-area
        v-bind="$attrs"
        class="mb-4"
        :value="value"
        :label="field.title"
        :rules="rules"
        :required="required"
        :counter="getMaxLength"
        v-on="$listeners" />
</template>

<script>
import formFieldMixin from "./formFieldMixin";

export default {
    types: ["textArea"],
    mixins: [formFieldMixin]
};
</script>
